import React from 'react';
import AssetTable from '../components/AssetTable';

export default function ForexPage() {
  return <AssetTable type="forex" title="Devisen" icon="fa-solid fa-money-bill-transfer" chartType="stock" />;
}
